import React, { useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { HoursInput } from './hours-input';
import { MinutesInput } from './minutes-input';
import { deserialize } from '../helpers';
import { useTranslation } from '../../../contexts/translation-context';
import { classes } from './time-input.st.css';
import { useConfig } from '../../../contexts/config-context';
export const TimeInput = _ref => {
  let {
    disabled,
    use24Hours,
    placeholder,
    onChange,
    onNext,
    minutesRef = /*#__PURE__*/React.createRef(),
    value,
    readOnly,
    inputId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    isRTL: rtl
  } = useConfig();
  const [HH, MM] = useMemo(() => (placeholder == null ? void 0 : placeholder.split(':')) || [], [placeholder]);
  const [tempHours, setTempHours] = useState(undefined);
  const {
    hours,
    minutes,
    period
  } = deserialize(value, use24Hours);
  const hoursRef = useRef(null);
  const hoursAriaBy = `hours-${inputId}`;
  const minutesAriaBy = `minutes-${inputId}`;
  const focusOnHours = key => {
    var _hoursRef$current;
    (_hoursRef$current = hoursRef.current) == null || _hoursRef$current.focus();
    if (key === 'Backspace' && hours !== undefined) {
      const newHours = hours.substring(0, hours.length - 1);
      setTempHours(newHours);
    }
  };
  const handleHoursNext = (_, isNumber) => {
    var _minutesRef$current3;
    if (isNumber) {
      var _minutesRef$current, _minutesRef$current2;
      (_minutesRef$current = minutesRef.current) == null || _minutesRef$current.setSelectionRange(0, (_minutesRef$current2 = minutesRef.current) == null ? void 0 : _minutesRef$current2.value.length);
    }
    (_minutesRef$current3 = minutesRef.current) == null || _minutesRef$current3.focus();
  };
  const handleMinutesChange = newMinutes => {
    onChange(hours, newMinutes);
  };
  const handleHoursChange = (newHours, newPeriod) => {
    setTempHours(newHours);
    onChange(newHours, minutes, newPeriod);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(HoursInput, {
    ref: hoursRef,
    value: tempHours ?? hours,
    placeholder: HH,
    use24Hours: use24Hours,
    disabled: disabled,
    readOnly: readOnly,
    period: period,
    "aria-describedby": hoursAriaBy,
    className: classNames(classes.hours, {
      [classes.rtl]: rtl
    }),
    onChange: handleHoursChange,
    onNext: handleHoursNext,
    onFocus: () => setTempHours(hours),
    onBlur: () => setTempHours(undefined)
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: classNames(classes.colon, {
      [classes.colonDisabled]: disabled
    })
  }, ":"), /*#__PURE__*/React.createElement(MinutesInput, {
    ref: minutesRef,
    placeholder: MM,
    value: minutes,
    disabled: disabled,
    readOnly: readOnly,
    "aria-describedby": minutesAriaBy,
    className: classNames(classes.minutes, {
      [classes.rtl]: rtl
    }),
    onChange: handleMinutesChange,
    onPrev: focusOnHours,
    onNext: onNext
  }), /*#__PURE__*/React.createElement("span", {
    id: hoursAriaBy,
    className: classes.hiddenA11y
  }, t('field.time.label.hours')), /*#__PURE__*/React.createElement("span", {
    id: minutesAriaBy,
    className: classes.hiddenA11y
  }, t('field.time.label.minutes')));
};
//# sourceMappingURL=time-input.js.map